import { createContext, useContext } from 'react';

export type ChunkUploadFunction = (
  chunkIndex: number,
  opfsSessionId: string,
) => Promise<void>;

export interface ChunkUploadContextValue {
  queueChunkUpload: ChunkUploadFunction | null;
  setQueueChunkUpload: (fn: ChunkUploadFunction | null) => void;
}

export const ChunkUploadContext = createContext<ChunkUploadContextValue>({
  queueChunkUpload: null,
  setQueueChunkUpload: () => {},
});

export const useChunkUpload = (): ChunkUploadContextValue => {
  return useContext(ChunkUploadContext);
};
